// @owners { team: patients-team }
import { useNavigation } from '@alto/navigation';

export const useIsInCheckout = () => {
  const { getCurrentRouteName } = useNavigation();
  const currentRoute = getCurrentRouteName();
  return currentRoute && ['RouteCheckout', '/checkout'].includes(currentRoute);
};
